export default "__VITE_PUBLIC_ASSET__7fdfbb0a__"